import { Link } from 'react-router-dom';
import { categories, featuredProducts, brands } from '@/mocks/products';
import { articles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const featuredArticles = articles.filter((a) => a.featured);

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cream%20minimalist%20abstract%20background%20with%20soft%20textured%20layers%20and%20gentle%20curved%20shapes%2C%20light%20beige%20and%20cream%20tones%2C%20subtle%20gradient%2C%20elegant%20and%20calm%20atmosphere%2C%20artistic%20composition%2C%20no%20text%2C%20no%20objects&width=1600&height=900&seq=hero-main-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
          <div className="relative z-10 w-full text-center px-4 md:px-6">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 tracking-wide">
              精品国产
            </h1>
            <p className="text-base md:text-xl text-white/90 max-w-2xl mx-auto mb-3 leading-relaxed">
              汇聚中国匠心制造的高品质国货精品
            </p>
            <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed">
              从日用百货到科技电子，严选真正值得信赖的精品国产好物，助您告别踩坑，轻松找到性价比之王。品质保证，放心选购。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/keji-dianzi"
                className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                探索好物
              </Link>
              <Link
                to="/article/2024-guohuo-shouji-pingce"
                className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
              >
                精选文章
              </Link>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                热门分类
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
                六大品类，覆盖日常生活的方方面面，发现属于你的国货好物
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-500 mt-1 text-center leading-tight">
                    {cat.description.slice(0, 20)}...
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10 md:mb-14">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                  精选推荐
                </h2>
                <p className="text-sm md:text-base text-foreground-600">
                  匠心严选，为国货品质把关
                </p>
              </div>
              <Link
                to="/category/keji-dianzi"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {featuredProducts.map((product) => (
                <div
                  key={product.id}
                  className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:shadow-md transition-all cursor-pointer"
                >
                  <div className="relative w-full aspect-square overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      title={`${product.name} - 精品国产推荐`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    {product.badge && (
                      <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full">
                        {product.badge}
                      </span>
                    )}
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className="text-xs text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">
                        {product.brand}
                      </span>
                      <Link
                        to={`/category/${product.category}`}
                        className="text-xs text-foreground-500 hover:text-primary-600 transition-colors"
                      >
                        {product.categoryName}
                      </Link>
                    </div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1.5 line-clamp-2 leading-snug">
                      {product.name}
                    </h3>
                    <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                      {product.description}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-base font-semibold text-accent-600">
                        {product.price}
                      </span>
                      <div className="flex items-center gap-1 text-xs text-foreground-500">
                        <i className="ri-star-fill text-accent-500 text-xs"></i>
                        <span>{product.rating}</span>
                        <span>({product.reviews.toLocaleString()})</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex justify-center mt-8 sm:hidden">
              <Link
                to="/category/keji-dianzi"
                className="flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10 md:mb-14">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                  精选文章
                </h2>
                <p className="text-sm md:text-base text-foreground-600">
                  深度评测与选购指南，帮你做明智的消费决策
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {featuredArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:shadow-md transition-all cursor-pointer"
                >
                  <div className="relative w-full h-48 overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full">
                        {article.categoryName}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-base md:text-lg font-medium text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-500">
                      <div className="flex items-center gap-3">
                        <span>{article.author}</span>
                        <span>{article.date}</span>
                      </div>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                合作品牌
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
                与优秀的国货品牌携手，为您甄选值得信赖的好产品
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {brands.map((brand) => (
                <div
                  key={brand.name}
                  className="flex flex-col items-center p-5 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                >
                  <div className="w-16 h-16 rounded-full overflow-hidden mb-3 bg-background-50">
                    <img
                      src={brand.logo}
                      alt={`${brand.name} 品牌`}
                      title={`${brand.name} - ${brand.description}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-sm font-semibold text-foreground-800 mb-1">
                    {brand.name}
                  </span>
                  <span className="text-xs text-foreground-500 text-center leading-tight">
                    {brand.productCount.toLocaleString()}+ 好物
                  </span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-500">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 dark:text-foreground-950 mb-3">
              发现更多国货精品
            </h2>
            <p className="text-sm md:text-base text-background-100 dark:text-foreground-900 mb-8 max-w-lg mx-auto">
              每周更新精选国货好物推荐，第一时间获取最新评测与优惠信息
            </p>
            <Link
              to="/category/keji-dianzi"
              className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 rounded-full text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              开始探索 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}